module.exports = __webpack_public_path__ + "img/BOEP-Header.cf220a2f.jpg";